import React__default, { useContext } from 'react';
import { jsx } from '@emotion/react';

var TabContext = /*#__PURE__*/React__default.createContext({});
var useTabContext = function useTabContext() {
  return useContext(TabContext);
};
function TabContextProvider(_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value;
  return jsx(TabContext.Provider, {
    value: value
  }, children);
}

export { TabContextProvider, useTabContext };
//# sourceMappingURL=TabContext.js.map
